<template>
  <div class="content">
    <h3> Informações da Empresa </h3>
    <div class="line">
      <div class="col6">
        <h3> Contato Empresa:</h3>
        <br/>
        Telefone: <br/><input type="text" class="inputWire" style="width:100%" v-model="$store.state.company.phone" />
        <br/><br/>
        Email em cópia da venda do cliente ( separados por ; ): <br/><input type="text" style="width:100%" class="inputWire" v-model="$store.state.company.companyMailCopy" />
        <br/><br/>
        Email: <br/><input type="text" style="width:100%" class="inputWire" v-model="$store.state.company.mailBook" />
        <br/><br/><br/>


        <h3> Parcelamento de Pagamento ONLINE:</h3>
        <br/>
        Quantidade Máxima de Parcelas: <br/><input type="number" class="inputWire" style="width:100%" v-model.number="$store.state.company.instalment.max_instalment" />
        <br/><br/>
        Valor Mínimo da Parcela: <br/><input type="number" class="inputWire" style="width:100%" v-model.number="$store.state.company.instalment.min_value" />
        <br/><br/>
        Quantidade de Parcelas sem juros: <br/><input type="number" class="inputWire" style="width:100%" v-model.number="$store.state.company.instalment.max_instalment_no_fee" />
        <br/><br/>
        Juros ao mês (decimal) Ex: 0,1 = 10%: <br/><input type="number" class="inputWire" style="width:100%" v-model.number="$store.state.company.instalment.month_fee_percent" />
        <br/><br/>

      </div>

      <div class="col6" v-if="!iamParent()">
        <h3> A Loja Filha vende bebidas alcoólicas? </h3>
        Ativar selo de "Proibida venda de bebidas alcoólicas para menores de 18 anos": <br/>
        Sim <input type="radio" :value="true" name="ageRestriction" v-model="$store.state.company.age_restriction"/>
        Não <input type="radio" :value="false" name="ageRestriction" v-model="$store.state.company.age_restriction"/>
        <br/>
      </div>

      <div class="col6" v-if="this.$store.state.company.company_type === 'DRUGSTORE'">
        <h3> Informações Rodapé (exclusivo para farmácias) :</h3>
        Ativar selo ANVISA: <br/>
        Sim <input type="radio" :value="true" name="activeAnvisa" v-model="$store.state.company.active_anvisa"/>
        Não <input type="radio" :value="false" name="activeAnvisa" v-model="$store.state.company.active_anvisa"/>
        <br/><br/>
        Texto Normativo ANVISA: <br/>
        <textarea style="width:100%;height:200px;" class="inputWire" v-model="$store.state.company.normative_anvisa"/>
      </div>


      <div class="col6">
        <h3> Políticas de Privacidade</h3>
        Adicionar arquivo PDF da Políticas de Privacidade de sua empresa:<br/>
        <input @change="savePDF($event,'privacy')" type="file"/>
      </div>

      <div class="col6">
        <h3> Termos de Uso</h3>
        Adicionar arquivo PDF da Termos de Uso de sua empresa:<br/>
        <input @change="savePDF($event,'termo')" type="file"/>
      </div>

      <div class="col6">
        <h3> Informações sobre Ícones (home da loja) :</h3>
        Área de entrega: (ícone caminhão) <br/><input type="text" style="width:100%" class="inputWire" v-model="$store.state.company.delivery_region"/>
        <br/><br/>
        Cartões aceitos (ícone cartões): <br/><input type="text" style="width:100%" class="inputWire" v-model="$store.state.company.cards_accepted"/>
        <br/><br/>
        Segurança Site (ícone escudo): <br/><input type="text" style="width:100%" class="inputWire" v-model="$store.state.company.security_information"/>
        <br/><br/>

        <h3> Clube de Fidelidade :</h3>
        Ativar Clube de Fidelidade: <br/>
        Sim <input name="fidelidade" type="radio" :value="true" v-model="$store.state.company.hasMembership"/>
        Não <input name="fidelidade" type="radio" :value="false" v-model="$store.state.company.hasMembership"/>
        <br/><br/>

        Ativar Filtro de Estoque : <br/>
        Sim <input name="estoque" type="radio" :value="true" v-model="$store.state.company.stock_configuration"/>
        Não <input name="estoque" type="radio" :value="false" v-model="$store.state.company.stock_configuration"/>
        <br/><br/>

        <h3> Tipo de empresa :</h3>
        Alterar tipo de empresa: <br/>
        <select name="selectCompanyType" v-model="$store.state.company.company_type">
          <option v-for="(ct, idx) in companyTypes" v-bind:key="idx" :value="ct.cod" :selected="ct.cod">{{ct.name}}</option>
        </select>
        <br/><br/>
        <button @click="saveKeys()">Salvar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/utils/event-bus'
import axios from 'axios'
import CompanyTypeConn from '@/connection/companyType'

export default {

  data () {
    return {
      companyTypes: [{cod: 'ECOMMERCE', type: 'ecommerce', name: 'E-commerce'}, {cod: 'BUTCHERY', type: 'casa de carne', name: 'Casa de carne'}, {cod: 'FROZEN FOOD', type: 'congelados', name: 'Congelados'}, {cod: 'BEVERAGE DISTRIBUTORS', type: 'distribuidora de bebidas', name: 'Distribuidora de bebidas'}, {cod: 'DRUGSTORE', type: 'farmacia', name: 'Farmácia'}, {cod: 'MARKET', type: 'mercado', name: 'Mercado'}, {cod: 'PERFUMERY', type: 'perfumaria', name: 'Perfumaria'}, {cod: 'PETSHOP', type: 'petshop', name: 'Petshop'}, {cod: 'RESTAURANT', type: 'restaurante', name: 'Restaurante'}],
      active_anvisa: null,
      age_restriction: null,
    }
  },

  computed: {
    ...mapGetters([ 'getOpaApi' ]),
  },

  created () {
    if (!this.$store.state.company.instalment) {
      this.$store.state.company.instalment = {
        max_instalment: 0,
        min_value: 0,
        max_instalment_no_fee: 0,
        month_fee_percent: 0
      }
    }
    if(!this.$store.state.company.company_type){
      this.$store.state.company.company_type = 0
    }
    if (!this.$store.state.company.active_anvisa) {
      this.$store.state.company.active_anvisa = false
    }
    if (!this.$store.state.company.hasMembership) {
      this.$store.state.company.hasMembership = false
    }
    if (!this.$store.state.company.stock_configuration) {
      this.$store.state.company.stock_configuration = false
    }
    if (!this.$store.state.company.age_restriction) {
      this.$store.state.company.age_restriction = false
    }
  },

  methods: {

    async saveKeys () {
      try {
        EventBus.$emit('showLoading', true)
        let data = {
          phone: this.$store.state.company.phone,
          companyMailCopy: this.$store.state.company.companyMailCopy,
          mailBook: this.$store.state.company.mailBook,
          delivery_region: this.$store.state.company.delivery_region,
          cards_accepted: this.$store.state.company.cards_accepted,
          security_information: this.$store.state.company.security_information,
          hasMembership: this.$store.state.company.hasMembership,
          active_anvisa: this.$store.state.company.active_anvisa,
          stock_configuration: this.$store.state.company.stock_configuration,
          validate_stock: this.$store.state.company.stock_configuration,
          company_type: this.$store.state.company.company_type,
          instalment: this.$store.state.company.instalment,
          age_restriction: this.$store.state.company.age_restriction,
        }
        if (this.$store.state.company.normative_anvisa && this.$store.state.company.normative_anvisa.length  ){
          data.normative_anvisa = this.$store.state.company.normative_anvisa
        } else {
          data.normative_anvisa = null
        }
        let result = await axios.patch(this.getOpaApi +'/company/' + this.$store.state.company.Id, data)
        if (result.data) {
          this.$store.commit('setCompany', result.data)
        }
        EventBus.$emit('showLoading', false)
        EventBus.$emit('showAlert', 'success', 'informações atualizadas')
      } catch(e) {
        let error = {e}
        console.log(error)
        EventBus.$emit('showAlert', 'error', 'erro ao atualizar informações')
        EventBus.$emit('showLoading', false)
      }
    },

    async loadCompanyType () {
      let result = await CompanyTypeConn.getCompanyType()
      console.log(result)
      if (result.error) {
        this.company_type = {
          cod : 0,
          type: null
        }
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        if (!result.company_type){
          this.company_type = {
            cod : 0,
            type: null
          }
        } else {
          this.company_type = result.company_type
        }
      }
      console.log(this.company_type)
      this.loading = false
      EventBus.$emit('showLoading', false)

    },

    async saveCompanyType () {
      EventBus.$emit('showLoading', true)
      let result = await CompanyTypeConn.saveCompanyType(this.company_type)
      EventBus.$emit('showLoading', false)
      if (!result.error) {
        this.company_type = result.company_type
        EventBus.$emit('showAlert', 'success', 'Tipo de empresa atualizado!')
      } else {
        EventBus.$emit('showAlert', 'error', result.msg)
      }
    },

    iamParent () {
      return this.$store.state.company.parent_company_id ? false : true
    },

    savePDF(event, fileType) {
      if (event.target.value) {
        let bodyFormData = new FormData()
        bodyFormData.append('file', event.target.files[0])
        EventBus.$emit('showLoading', true)
        axios({
          method: 'post',
          url: this.getOpaApi + '/files/company/' + this.$store.state.company.companyId + '/privacy/?file_name=' + fileType + '.pdf',
          data: bodyFormData,
          config: {headers: {'Content-Type': 'form-data'}}
        })
          .then(function () {
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'Arquivo atualizado')
          })
          .catch(function () {
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'Erro ao subir arquivo')
          })
      }
    }
  }
}
</script>
